import Validation from "utils/validation.utils";

const initialState = (refNumber) => {
  return {
    refNumber: {
      name: "refNumber",
      value: refNumber || "",
      required: true,
      innerLabel: false,
      maxLength: 25,
      placeholder: "123456789",
      validations: [Validation.required()],
    },
  };
};

export default initialState;
